
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M12.08 2.746a.585.585 0 00-.826-.825L7 6.175 2.746 1.921a.583.583 0 10-.825.825L6.175 7l-4.254 4.254a.583.583 0 10.825.825L7 7.825l4.254 4.254a.583.583 0 10.825-.825L7.825 7l4.254-4.254z","clip-rule":"evenodd"}})])
          )
        }
      }
    